import Svg, { ClipPath, G, Defs, Path, Rect } from "react-native-svg";
const FlagIcon = () => (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clip-path="url(#clip0_7637_1365)">
            <Path d="M13.2007 5.49935L12.834 3.66602H4.58398V19.2493H6.41732V12.8327H11.5507L11.9173 14.666H18.334V5.49935H13.2007Z" fill="#323232" />
        </G>
        <Defs>
            <ClipPath id="clip0_7637_1365">
                <Rect width="22" height="22" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>

);
export default FlagIcon;
